/**
 * Gemensam query för prislistan från skolsystemet.
 *
 * Ligger separat (inte i en komponent) så att rot-routen kan förladda den
 * utan att dra in avgiftstabellens kod i startpaketet.
 */
import { queryOptions } from "@tanstack/react-query";

import { getSitePricing } from "@/lib/pricing.functions";

export const sitePricingQuery = queryOptions({
  queryKey: ["site-pricing"],
  // Ett avbrutet eller tomt svar (t.ex. under en ny version) gav tidigare ett
  // kraschande "Query data cannot be undefined". Nu blir det ett vanligt fel
  // som går att försöka om.
  queryFn: async () => {
    const result = await getSitePricing();
    if (!result) throw new Error("Prislistan kunde inte hämtas just nu");
    return result;
  },
  retry: 1,
  staleTime: 5 * 60 * 1000,
  gcTime: 30 * 60 * 1000,
});
